/** Sidebar navigation — single source of truth for Layout. */
export const NAV_GROUPS = [
  { key: 'overview', label: 'Overview' },
  { key: 'commerce', label: 'Commerce' },
  { key: 'people', label: 'People' },
  { key: 'content', label: 'Content' },
  { key: 'catalog', label: 'Catalog' },
];

export const ALL_NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', path: '/dashboard', group: 'overview', icon: '◆' },
  { id: 'products', label: 'Products', path: '/products', group: 'commerce', icon: '▣' },
  { id: 'orders', label: 'Orders', path: '/orders', group: 'commerce', icon: '◎' },
  { id: 'abandoned-checkouts', label: 'Abandoned carts', path: '/abandoned-checkouts', group: 'commerce', icon: '◌' },
  { id: 'reservations', label: 'Reservations', path: '/reservations', group: 'commerce', icon: '◷' },
  { id: 'auctions', label: 'Live auctions', path: '/auctions', group: 'commerce', icon: '◉' },
  { id: 'auction-deposits', label: 'Auction deposits', path: '/auction-deposits', group: 'commerce', icon: '◇' },
  { id: 'customers', label: 'Customers', path: '/customers', group: 'people', icon: '○' },
  { id: 'users', label: 'Team users', path: '/users', group: 'people', icon: '●' },
  { id: 'closet', label: 'Closet accounts', path: '/closet', group: 'people', icon: '◈' },
  { id: 'blogs', label: 'Blog', path: '/blogs', group: 'content', icon: '▥' },
  { id: 'style-collections', label: 'Style collections', path: '/style-collections', group: 'content', icon: '▦' },
  { id: 'home-banner', label: 'Home banner', path: '/home-banner', group: 'content', icon: '▧', settingsOnly: true },
  { id: 'categories', label: 'Categories', path: '/categories', group: 'catalog', icon: '▨' },
  { id: 'brands', label: 'Brands', path: '/brands', group: 'catalog', icon: '▩' },
  { id: 'colors', label: 'Colors', path: '/colors', group: 'catalog', icon: '◐' },
  { id: 'conditions', label: 'Conditions', path: '/conditions', group: 'catalog', icon: '◑' },
  { id: 'locations', label: 'Locations', path: '/locations', group: 'catalog', icon: '◒' },
];

export const INFLUENCER_HIDDEN_NAV_IDS = [
  'users',
  'customers',
  'colors',
  'conditions',
  'locations',
  'brands',
  'blogs',
  'style-collections',
  'auctions',
  '/auction-deposits',
  'abandoned-checkouts',
  'closet',
  'categories',
  'home-banner',
];

export const AUCTION_NAV_IDS = ['auctions', 'auction-deposits'];

export function buildNavItems({ isInfluencer, auctionsEnabled }) {
  let items = isInfluencer
    ? ALL_NAV_ITEMS.filter((item) => !INFLUENCER_HIDDEN_NAV_IDS.includes(item.id))
    : ALL_NAV_ITEMS.filter((item) => !item.settingsOnly);

  if (!auctionsEnabled) {
    items = items.filter((item) => !AUCTION_NAV_IDS.includes(item.id));
  }

  return items;
}

export function resolvePageTitle(pathname, navItems) {
  const p = pathname || '';
  const exact = navItems.find(
    (item) =>
      p === item.path ||
      (p === '/' && item.id === 'dashboard') ||
      (item.path !== '/' && p.startsWith(`${item.path}/`)),
  );
  if (exact) return exact.label;

  if (p === '/settings') return 'Settings';
  if (p.startsWith('/settings') || p.includes('settings')) return 'Settings';

  const fallbacks = [
    { prefix: '/products', label: 'Products' },
    { prefix: '/orders', label: 'Orders' },
    { prefix: '/abandoned-checkouts', label: 'Abandoned carts' },
    { prefix: '/users', label: 'Team users' },
    { prefix: '/customers', label: 'Customers' },
    { prefix: '/auctions', label: 'Live auctions' },
    { prefix: '/mail-settings', label: 'Mail & templates' },
    { prefix: '/permissions', label: 'Permissions' },
  ];
  const hit = fallbacks.find((f) => p.startsWith(f.prefix));
  return hit?.label || 'Dashboard';
}
